import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
export const getSocialNetworks = basicSelector(state => state.socialNetworks);